// extracted by mini-css-extract-plugin
export default {"wrapper":"InputMessage_wrapper__Kius7","quill":"InputMessage_quill__Cro62"};